import AchievmentsBar from './AchievmentsBar';

export default AchievmentsBar;
